import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../utils/axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        page_config: []
    },
    mutations: {
        setPageConfig(state,conf){
            state.page_config = conf;
        },
        setPageShareConfig(state, path) {
            let conf = state.page_config;
            if(!conf) return ;
            for (let i = 0, len = conf.length; i < len; i++) {
                if (conf[i].path === path) {
                    window.shareConf.fx_url = window.location.href;
                    window.shareConf.fx_title = conf[i].title;
                    window.shareConf.fx_memo = conf[i].desc;
                    window.shareConf.fx_pic = conf[i].img;
                    window.shareDiy();
                }
            }
        }
    },
    actions: {
        getPageConfig(state) {
            axios.get("/m/system/get_page_config").then(res => {
               state.commit('setPageConfig',res);
            })
        }
    },
    modules: {}
})
